import React, { useEffect } from 'react';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import SkillsSection from './components/SkillsSection';
import ExperienceSection from './components/ExperienceSection';
import ProjectsSection from './components/ProjectsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

const PortfolioHomepage = () => {
  useEffect(() => {
    // Set page title
    document.title = 'Harsh Tiwari - Full-Stack Developer | MERN Specialist';
    
    // Add meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription?.setAttribute('content', 'Full-Stack Developer specializing in MERN stack technologies. Building scalable web applications with React, Node.js, MongoDB, and Express.js.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Full-Stack Developer specializing in MERN stack technologies. Building scalable web applications with React, Node.js, MongoDB, and Express.js.';
      document.getElementsByTagName('head')?.[0]?.appendChild(meta);
    }

    // Intersection Observer for fade-in animations
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in');
        }
      });
    }, observerOptions);

    // Observe all sections for animations
    const sections = document.querySelectorAll('section');
    sections?.forEach((section) => {
      observer?.observe(section);
    });

    // Cleanup observer on unmount
    return () => {
      sections?.forEach((section) => {
        observer?.unobserve(section);
      });
    };
  }, []);

  return (
    <div className="min-h-screen bg-background">
      {/* Header with Navigation */}
      <Header />
      
      {/* Main Content */}
      <main className="relative">
        {/* Hero Section */}
        <HeroSection />
        
        {/* About Section */}
        <AboutSection />
        
        {/* Skills Section */}
        <SkillsSection />
        
        {/* Experience Section */}
        <ExperienceSection />
        
        {/* Projects Section */}
        <ProjectsSection />
        
        {/* Contact Section */}
        <ContactSection />
      </main>
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default PortfolioHomepage;